import * as React from 'react';

export interface ResponseMetaData {
	intent: string;
	confidenceScore?: number;
}

export interface ResponseMetaDataProps {
	responseMetaData: ResponseMetaData;
}

export const ResponseMetaData = React.forwardRef<
	HTMLDivElement,
	ResponseMetaDataProps
>(({ responseMetaData }, ref) => {
	return (
		<div
			ref={ref}
			className="text-caption text-center text-gray-100"
			style={{ background: '#FFB165' }}
		>
			Intent: <strong>{responseMetaData.intent}</strong> | Confidence:{' '}
			<strong>{responseMetaData.confidenceScore}</strong>
		</div>
	);
});

export default ResponseMetaData;
